export default __webpack_public_path__ + "static/media/a012-market-line-8.6f6b0339.svg";